module.exports = __webpack_public_path__ + "static/media/tbt.b98b7c1c.PNG";